import { Injectable, Injector, NgZone } from '@angular/core';
import { DwGlobalErrorHandler } from '@devwareapps/devware-cap';

import { environment } from '../../../../environments/environment';

@Injectable()
export class AviatorGlobalErrorHandler extends DwGlobalErrorHandler {
  private readonly forwardedErrors = new WeakSet<Error>();

  constructor(injector: Injector, private readonly ngZone: NgZone) {
    super(injector);
  }

  handleError(error: Error): void {
    super.handleError(error);

    const posthog = (window as Window & {
      posthog?: { captureException?: (exception: Error) => void };
    }).posthog;
    const originalError = (error && (error as Error & { ngOriginalError?: Error }).ngOriginalError) || error;

    if (!environment.postHog.enabled || !posthog || !posthog.captureException ||
      !(originalError instanceof Error) || this.forwardedErrors.has(originalError)) {
      return;
    }

    this.forwardedErrors.add(originalError);
    this.ngZone.runOutsideAngular(() => {
      try {
        posthog.captureException(originalError);
      } catch (captureError) {
        // Telemetry failures must not trigger another Angular error-handling cycle.
        console.error('Unable to forward Angular exception to PostHog.', captureError);
      }
    });
  }
}
